export type PropertyDependencyAnnotationTypeEnum = 'Value' | 'ReadOnly' | 'Visible';
export const PropertyDependencyAnnotationTypeEnum = {
	Value:    'Value' as PropertyDependencyAnnotationTypeEnum,
	ReadOnly: 'ReadOnly' as PropertyDependencyAnnotationTypeEnum,
	Visible:  'Visible' as PropertyDependencyAnnotationTypeEnum
};

